import * as wjcCore from '@mescius/wijmo';
import * as wjGridFilter from '@mescius/wijmo.grid.filter';
import * as wjMultirow from '@mescius/wijmo.grid.multirow';
import * as wjNav from '@mescius/wijmo.nav';

'use strict';

import {ViewChild, Component, AfterViewInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {HttpClient} from '@angular/common/http';
import {Store} from '@ngrx/store';
import {ToasterService} from 'angular2-toaster';
import {TranslocoService} from '@jsverse/transloco';
import {ActivePromotionConfig} from '../config/active-promotion.config';
import {GalleryComponent, GalleryItem, ImageItem} from '../ui/gallery/index';
import {asOrientDate, isOrientDate, DataService, OrientDBCollectionView} from '@cosbeni/database';
import {LoadUserAction} from '../ngrx/actions/user.action';

@Component({
    standalone: false,
    selector: 'cj-user-bid',
    templateUrl: 'bid.component.html',
    styleUrls: ['bid.component.css']
})

export class BidComponent implements AfterViewInit {
    readonly: Boolean = true;
    @ViewChild('itemGrid') itemGrid: wjMultirow.MultiRow;
    @ViewChild('imageGallery') imageGallery: GalleryComponent;
    @ViewChild('itemTabPanel') itemTabPanel: wjNav.TabPanel;
    filter: wjGridFilter.FlexGridFilter;
    predicate: any = {
        id: null,
        place: '',
        lane: '',
        category: '',
        auctionResult: '',
        buyer: null,
        seller: null,
        name: '',
        description: '',
        eventDate: null,
    };
    screenWidth: number;
    user: any;
    now: Date = new Date();
    price: number = 0;
    item: any = {};
    items: OrientDBCollectionView;
    histories: wjcCore.CollectionView = new wjcCore.CollectionView([]);
    bids: any[] = [];
    confirm: boolean = false;
    view: string = 'easy';
    mode: string = 'view';
    tableType: string = 'image';
    galleryItems: GalleryItem[];
    optionAuction: any[] = [];
    optionAuctionResult: any[] = [];
    optionCategory: any[] = [];
    optionLane: any[] = [];
    optionPlace: any[] = [];
    optionUnit: any[] = [];
    cancelTabIndex: number = 0;

    constructor(public store: Store<any>, public dataService: DataService, public toasterService: ToasterService, private transloco: TranslocoService, private route: ActivatedRoute, private http: HttpClient) {
        this.store.dispatch(new LoadUserAction());
        this.store.select<any>('activePromotionFeature').subscribe((digitalAuction: any) => {
            if (wjcCore.isObject(digitalAuction.user) && digitalAuction.user.loaded) {
                this.user = digitalAuction.user.user;
                if (wjcCore.isObject(this.items)) {
                    this.items.filterOnServer = true;
                }
            }
        });
        this.items = new OrientDBCollectionView(dataService, ActivePromotionConfig.DATABASE, 'SELECT FROM DA_Item', 'DA_Item', '', 0, 20, true, true, false);
        this.items.url = ActivePromotionConfig.SERVER_URL;
        this.items.tokenName = ActivePromotionConfig.DATABASE + '_token';
        this.items.sortDescriptions.push(new wjcCore.SortDescription("auction.eventDate", false));
        this.items.sortDescriptions.push(new wjcCore.SortDescription("sort", true));
        this.items.fetchPlan = '*:0 auction:1';
        this.dataService.query({
            sql: 'SELECT FROM DA_Auction ORDER BY eventDate DESC',
            count: 'SELECT FROM DA_Auction ORDER BY eventDate DESC',
            fetchPlan: '*:1',
        }, ActivePromotionConfig.SERVER_URL).subscribe(data => {
            if (wjcCore.isArray(data.results)) {
                for (let auction of data.results) {
                    if (isOrientDate(auction.eventDate)) {
                        auction.eventDate = asOrientDate(auction.eventDate);
                        auction.display = wjcCore.Globalize.formatDate(auction.eventDate, 'yyyy/MM/dd HH:mm:ss') + ' ' + auction.place + ' ' + auction.lane;
                    }
                }
                this.optionAuction = data.results;
            }
        });
        this.dataService.query({
            sql: 'SELECT FROM DA_Master WHERE category =\'セリ結果\' order by sort',
            count: 'SELECT FROM DA_Master WHERE category =\'セリ結果\' order by sort',
            fetchPlan: '*:1',
        }, ActivePromotionConfig.SERVER_URL).subscribe(data => {
            if (wjcCore.isArray(data.results)) {
                this.optionAuctionResult = data.results;
            }
        });
        this.dataService.query({
            sql: 'SELECT FROM DA_Master WHERE category =\'商品種別\' order by sort',
            count: 'SELECT FROM DA_Master WHERE category =\'商品種別\' order by sort',
            fetchPlan: '*:1',
        }, ActivePromotionConfig.SERVER_URL).subscribe(data => {
            if (wjcCore.isArray(data.results)) {
                this.optionCategory = data.results;
            }
        });
        this.dataService.query({
            sql: 'SELECT FROM DA_Master WHERE category =\'レーン\' order by sort',
            count: 'SELECT FROM DA_Master WHERE category =\'レーン\' order by sort',
            fetchPlan: '*:1',
        }, ActivePromotionConfig.SERVER_URL).subscribe(data => {
            if (wjcCore.isArray(data.results)) {
                this.optionLane = data.results;
            }
        });
        this.dataService.query({
            sql: 'SELECT FROM DA_Master WHERE category =\'会場名\' order by sort',
            count: 'SELECT FROM DA_Master WHERE category =\'会場名\' order by sort',
            fetchPlan: '*:1',
        }, ActivePromotionConfig.SERVER_URL).subscribe(data => {
            if (wjcCore.isArray(data.results)) {
                this.optionPlace = data.results;
            }
        });
        this.dataService.query({
            sql: 'SELECT FROM DA_Master WHERE category =\'単位\' order by sort',
            count: 'SELECT FROM DA_Master WHERE category =\'単位\' order by sort',
            fetchPlan: '*:1',
        }, ActivePromotionConfig.SERVER_URL).subscribe(data => {
            if (wjcCore.isArray(data.results)) {
                this.optionUnit = data.results;
            }
        });
        this.resizeScreen();
    }

    resizeScreen(event?) {
        this.screenWidth = window.innerWidth;
    }

    ngAfterViewInit() {
        this.items.currentChanged.addHandler(this.onCurrentChanged, this);
        this.items.itemsSourceFunction = function (items: any[]) {
            for (let item of items) {
                if (wjcCore.isObject(item.auction) && isOrientDate(item.auction.eventDate)) {
                    item.auction.eventDate = asOrientDate(item.auction.eventDate);
                }
            }
            return items;
        };
        this.itemGrid.loadedRows.addHandler(this.onRowLoaded, this);
    }

    onCurrentChanged(sender: any, args: wjcCore.EventArgs): void {
        this.now = new Date();
        if (this.items.currentItem != null && this.mode == 'view') {
            this.item = Object.assign({}, this.items.currentItem);
            if (wjcCore.isObject(this.item.auction)) {
                for (let auction of this.optionAuction) {
                    if (auction['@rid'] == this.item.auction['@rid']) {
                        this.item.auction = auction;
                    }
                }
            }
            if (wjcCore.isObject(this.imageGallery)) {
                this.imageGallery.reset();
            }
            if (this.item.hasOwnProperty('images') && wjcCore.isArray(this.item.images)) {
                this.galleryItems = [];
                for (let name of this.item.images) {
                    this.galleryItems.push(new ImageItem({
                        src: ActivePromotionConfig.IMAGE_URL + this.item.id + '/' + name,
                        thumb: ActivePromotionConfig.IMAGE_URL + this.item.id + '/' + name
                    }));
                }
            }
            this.price = this.item.minimumPrice;
            this.loadHistories();
        }
    }

    pageChanged(event: any): void {
        this.items.moveToPage(event.page - 1);
    }

    showItem(item: any) {
        this.item = Object.assign({}, item);
        if (wjcCore.isObject(this.item.auction)) {
            for (let auction of this.optionAuction) {
                if (auction['@rid'] == this.item.auction['@rid']) {
                    this.item.auction = auction;
                }
            }
        }
        if (wjcCore.isObject(this.imageGallery)) {
            this.imageGallery.reset();
        }
        if (this.item.hasOwnProperty('images') && wjcCore.isArray(this.item.images)) {
            this.galleryItems = [];
            for (let name of this.item.images) {
                this.galleryItems.push(new ImageItem({
                    src: ActivePromotionConfig.IMAGE_URL + this.item.id + '/' + name,
                    thumb: ActivePromotionConfig.IMAGE_URL + this.item.id + '/' + name
                }));
            }
        }
        this.price = this.item.minimumPrice;
        this.loadHistories();
        this.itemTabPanel.selectedIndex = 1;
    }

    onRowLoaded(sender: any, args: wjcCore.EventArgs): void {
        let rows = sender.rows;
        for (let i = 0; i < rows.length; i++) {
            if (rows[i].dataItem.hasOwnProperty('buyer') && wjcCore.isObject(rows[i].dataItem.buyer) && wjcCore.isObject(this.user) && rows[i].dataItem.buyer['@rid'] == this.user['@rid']) {
                rows[i].cssClass = 'redRow';
            }
            if (rows[i].dataItem.hasOwnProperty('buyer') && wjcCore.isString(rows[i].dataItem.buyer) && wjcCore.isObject(this.user) && rows[i].dataItem.buyer == this.user['@rid']) {
                rows[i].cssClass = 'redRow';
            }
        }
    }

    createNew(): void {
        this.mode = 'edit';
    }

    cancelHistory(): void {
        this.mode = 'view';
        this.confirm = false;
        this.bids = [];
        if (this.items.currentItem != null) {
            this.item = Object.assign({}, this.items.currentItem);
        }
        this.itemTabPanel.selectedIndex = this.cancelTabIndex;
    }

    updateBid(): void {
        this.bids = [];
        this.bids.push({id: this.item.id, name: this.item.name, uuid: this.item.uuid, price: this.price});
        this.cancelTabIndex = 0;
        this.confirm = true;
    }

    confirmBids(): void {
        this.confirm = true;
        this.itemTabPanel.selectedIndex = 1;
        this.cancelTabIndex = 0;
    }

    updateBids(): void {
        for (let item of this.items.items) {
            if (item.selected) {
                if (this.hasBids(item.uuid)) {
                    for (let bid of this.bids) {
                        if (bid.uuid == item.uuid) {
                            bid.price = this.price;
                        }
                    }
                } else {
                    this.bids.push({id: item.id, name: item.name, uuid: item.uuid, price: this.price});
                }
                item.selected = false;
                this.items.refresh();
            }
        }
    }

    getBid(uuid: string): number {
        for (let bid of this.bids) {
            if (bid.uuid == uuid) {
                return bid.price;
            }
        }
        return 0;
    }

    hasBids(uuid: string): boolean {
        let bids = this.bids.filter(d => d.uuid == uuid);
        if (bids.length > 0) {
            return true;
        }
        return false;
    }

    toggleSelected(item): void {
        if (item.selected) {
            item.selected = false;
        } else {
            if (item.auction.eventDate.getTime() > new Date().getTime()) {
                item.selected = true;
            }
        }
    }

    canSelect(item): boolean {
        if (item.auction.eventDate.getTime() > new Date().getTime()) {
            return true;
        }
        return false;
    }

    saveHistory(): void {
        this.dataService.post(this.bids, ActivePromotionConfig.SERVER_URL + '/rest/auction/bid').subscribe(response => {
                if (response.message == 'success') {
                    this.toasterService.pop('info', this.transloco.translate('common.save'), this.transloco.translate('user.saved_message'));
                } else {
                    this.toasterService.pop('error', this.transloco.translate('common.save'), this.transloco.translate('user.bid_after_start'));
                }
                this.loadHistories();
                this.mode = 'view';
                this.confirm = false;
                this.bids = [];
            },
            (error: any) => {
                this.toasterService.pop('error', this.transloco.translate('common.save'), this.transloco.translate('user.failed_message'));
            });
    }

    loadHistories() {
        this.histories.sourceCollection = [];
        this.histories.refresh();
        if (this.items.currentItem != null && wjcCore.isObject(this.user)) {
            this.dataService.query({
                sql: 'SELECT FROM DA_History WHERE item = ' + this.item['@rid'] + ' AND buyer = ' + this.user['@rid'] + ' order by historyDate desc',
                count: 'SELECT FROM DA_History WHERE item = ' + this.item['@rid'] + ' AND buyer = ' + this.user['@rid'] + ' order by historyDate desc',
                fetchPlan: '*:1',
            }, ActivePromotionConfig.SERVER_URL).subscribe(data => {
                if (wjcCore.isArray(data.results)) {
                    for (let history of data.results) {
                        if (isOrientDate(history.historyDate)) {
                            history.historyDate = asOrientDate(history.historyDate);
                        }
                    }
                    this.histories.sourceCollection = data.results;
                    this.histories.refresh();
                }
            });
        }
    }

    search(name = ''): void {
        let where = ['auction.status IN [\'未開催\',\'終了\']', 'published >= date(\'2000-01-01\',\'yyyy-MM-dd\')'];
        if (!wjcCore.isNullOrWhiteSpace(name)) {
            if (name == '自社落札済') {
                where.push('auction.eventDate <= date(\'' + wjcCore.Globalize.formatDate(new Date(), 'yyyy-MM-dd HH:mm:ss') + '\',\'yyyy-MM-dd HH:mm:ss\')');
                where.push('auctionResult = \'落札\'');
                where.push('buyer = ' + this.user['@rid']);
            }
            if (name == '自社落札中') {
                where.push('auction.eventDate > date(\'' + wjcCore.Globalize.formatDate(new Date(), 'yyyy-MM-dd HH:mm:ss') + '\',\'yyyy-MM-dd HH:mm:ss\')');
                where.push('@rid IN (SELECT item FROM (SELECT count(*), item FROM DA_History WHERE buyer = ' + this.user['@rid'] + ' GROUP BY item))');
            }
            if (name == '落札可能') {
                where.push('auction.eventDate > date(\'' + wjcCore.Globalize.formatDate(new Date(), 'yyyy-MM-dd HH:mm:ss') + '\',\'yyyy-MM-dd HH:mm:ss\')');
            }
            if (name == '終了済') {
                where.push('auction.eventDate <= date(\'' + wjcCore.Globalize.formatDate(new Date(), 'yyyy-MM-dd HH:mm:ss') + '\',\'yyyy-MM-dd HH:mm:ss\')');
            }
            if (name == 'お気に入り') {
                where.push('followers IN [' + this.user['@rid'] + ']');
            }
        } else {
            if (wjcCore.isNumber(this.predicate.id)) {
                where.push('id = ' + this.predicate.id);
            }
            if (wjcCore.isDate(this.predicate.eventDate)) {
                where.push('auction.eventDate >= date(\'' + wjcCore.Globalize.formatDate(this.predicate.eventDate, 'yyyy-MM-dd') + '\',\'yyyy-MM-dd\')');
                where.push('auction.eventDate < date(\'' + wjcCore.Globalize.formatDate(wjcCore.DateTime.addDays(this.predicate.eventDate, 1), 'yyyy-MM-dd') + '\',\'yyyy-MM-dd\')');
            }
            if (!wjcCore.isNullOrWhiteSpace(this.predicate.place)) {
                where.push('auction.place = \'' + this.predicate.place + '\'');
            }
            if (!wjcCore.isNullOrWhiteSpace(this.predicate.lane)) {
                where.push('auction.lane = \'' + this.predicate.lane + '\'');
            }
            if (!wjcCore.isNullOrWhiteSpace(this.predicate.category)) {
                where.push('category = \'' + this.predicate.category + '\'');
            }
            if (!wjcCore.isNullOrWhiteSpace(this.predicate.auctionResult)) {
                where.push('auctionResult = \'' + this.predicate.auctionResult + '\'');
            }
            if (!wjcCore.isNullOrWhiteSpace(this.predicate.name)) {
                where.push('name LIKE \'%' + this.predicate.name + '%\'');
            }
            if (!wjcCore.isNullOrWhiteSpace(this.predicate.description)) {
                where.push('description LIKE \'%' + this.predicate.description + '%\'');
            }
        }
        this.items.filterOnServer = false;
        this.items.filterSpecial = where.join(' AND ');
        this.items.filterOnServer = true;
    }

    resetPredicate() {
        this.predicate = {
            id: null,
            place: '',
            lane: '',
            category: '',
            auctionResult: '',
            buyer: null,
            seller: null,
            name: '',
            description: '',
            eventDate: null,
        };
        this.search();
    }

    hasHighestBid(item): string {
        if (item.hasOwnProperty('buyer') && wjcCore.isObject(item.buyer) && wjcCore.isObject(this.user) && item.buyer['@rid'] == this.user['@rid']) {
            return '最高落札者';
        }
        if (item.hasOwnProperty('buyer') && wjcCore.isString(item.buyer) && wjcCore.isObject(this.user) && item.buyer == this.user['@rid']) {
            return '最高落札者';
        }
        return '';
    }

    getImageSrc(item, name): string {
        return ActivePromotionConfig.IMAGE_URL + item.id + '/' + name;
    }

    getCurrentImageSrc(name): string {
        return ActivePromotionConfig.IMAGE_URL + this.item.id + '/' + name;
    }

    addFollowers(item) {
        let sql = 'BEGIN\n';
        sql = sql + 'UPDATE DA_Item ADD followers = ' + this.user['@rid'] + ' WHERE @rid = ' + item['@rid'] + '\n';
        sql = sql + 'COMMIT RETRY 100\n';
        this.dataService.batch({sql: sql}, ActivePromotionConfig.SERVER_URL).subscribe((response: any) => {
                this.toasterService.pop('info', this.transloco.translate('user.favorites'), this.transloco.translate('user.added_message'));
                if (item.hasOwnProperty('followers') && wjcCore.isArray(item.followers)) {
                    item.followers.push(this.user['@rid']);
                } else {
                    item.followers = [this.user['@rid']];
                }
            },
            (error: any) => {
                this.toasterService.pop('error', this.transloco.translate('user.favorites'), this.transloco.translate('user.failed_message'));
            }
        );
    }

    removeFollowers(item) {
        let sql = 'BEGIN\n';
        sql = sql + 'UPDATE DA_Item REMOVE followers = ' + this.user['@rid'] + ' WHERE @rid = ' + item['@rid'] + '\n';
        sql = sql + 'COMMIT RETRY 100\n';
        this.dataService.batch({sql: sql}, ActivePromotionConfig.SERVER_URL).subscribe((response: any) => {
                this.toasterService.pop('info', this.transloco.translate('user.favorites'), this.transloco.translate('user.removed_message'));
                if (item.hasOwnProperty('followers') && wjcCore.isArray(item.followers) && item.followers.indexOf(this.user['@rid']) >= 0) {
                    let index = item.followers.indexOf(this.user['@rid']);
                    item.followers.splice(index, 1);
                }
            },
            (error: any) => {
                this.toasterService.pop('error', this.transloco.translate('user.favorites'), this.transloco.translate('user.failed_message'));
            }
        );
    }

    isFollowers(item) {
        let result = false;
        if (item.hasOwnProperty('followers') && wjcCore.isArray(item.followers) && item.followers.indexOf(this.user['@rid']) >= 0) {
            return true;
        }
        return result;
    }

}

